import React from 'react';
import PropTypes from 'prop-types';
import { Box, Image } from 'rebass/styled-components';

import Logo from '../../../assets/icon-getro-intro.svg';

export const NetworkOnboardingLayout = ({ children }) => (
  <Box minHeight="100vh" bg="neutral.0" sx={{ height: '100%' }}>
    <Box
      sx={{
        width: ['120px', '120px', '160px'],
        height: ['30px', '30px', '40px'],
        position: 'absolute',
        top: ['24px', '24px', '40px'],
        left: ['16px', '16px', '40px'],
      }}
    >
      <Image src={Logo} />
    </Box>
    {children}
  </Box>
);

NetworkOnboardingLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
